export const HEARTBEAT_PATH =
  'M5.715 40.149h6.578l1.941-6.878 4.108 11.309 4.581-21.812 4.387 16.791 3.702-10.418 3.614 14.333 3.576-8.521 3.108 5.193h5.931'
// The length of the heartbeat path in pixels.
export const HEARTBEAT_PATH_LENGTH = 113
export const HOUSE_PATH =
  'M40.592 41.44h6.649V56H5.743V41.44h7.497l1.131-4.032 4.299 11.805 4.389-20.884 4.065 15.56 3.69-10.382 3.533 13.852 4.048-9.585 2.197 3.666zm2.872-23.147V4.935h-8.613v4.074L26.492 0 0 28.56h5.743v10.304h5.574l2.742-9.763 3.955 10.846 4.773-22.74 4.703 18.021 3.721-10.454 3.734 14.613 3.063-7.256 4.019 6.72h5.214V28.56H53l-9.536-10.267z'
